module.exports = __webpack_public_path__ + "static/media/talk3.fd7f6403.png";